import React from 'react';

const Terms = () => {
  const styles = {
    header: { background: '#f7f7f7', padding: '60px 24px', textAlign: 'center' },
    title: { fontSize: '2.5rem', fontWeight: '700', marginBottom: '16px' },
    container: { maxWidth: '800px', margin: '0 auto', padding: '60px 24px' },
    section: { marginBottom: '32px' },
    sectionTitle: { fontSize: '1.25rem', fontWeight: '600', marginBottom: '16px' },
    text: { color: '#444', lineHeight: '1.8', marginBottom: '16px' }
  };

  return (
    <>
      <header style={styles.header}>
        <h1 style={styles.title}>Terms of Service</h1>
        <p style={{ color: '#555' }}>Last updated: January 2025</p>
      </header>

      <section style={styles.container}>
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>1. Acceptance of Terms</h2>
          <p style={styles.text}>
            By accessing and using the Kasbia Stays website and services, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>2. Booking and Reservations</h2>
          <p style={styles.text}>
            All bookings are subject to availability and confirmation. A booking is only confirmed once you receive a confirmation email and payment has been processed successfully.
          </p>
          <p style={styles.text}>
            You must be at least 18 years old to make a booking. By making a booking, you confirm that you have the legal capacity to enter into a binding contract.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>3. Cancellation Policy</h2>
          <p style={styles.text}>
            Cancellation policies vary by apartment and booking type. Please review the specific cancellation policy displayed during the booking process. Refunds will be processed according to the applicable policy.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>4. Guest Responsibilities</h2>
          <p style={styles.text}>
            Guests are responsible for treating the apartment and its contents with care. Any damage beyond normal wear and tear may result in charges. Guests must comply with all house rules and local regulations.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>5. Payment Terms</h2>
          <p style={styles.text}>
            Full payment is required at the time of booking unless otherwise specified. We accept major credit and debit cards. All prices are in GBP and include applicable taxes unless stated otherwise.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>6. Limitation of Liability</h2>
          <p style={styles.text}>
            Kasbia Stays shall not be liable for any indirect, incidental, or consequential damages arising from the use of our services. Our liability is limited to the amount paid for the booking.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>7. Changes to Terms</h2>
          <p style={styles.text}>
            We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting. Continued use of our services constitutes acceptance of modified terms.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>8. Contact</h2>
          <p style={styles.text}>
            For questions about these Terms of Service, please contact us at info@kasbiastays.co.uk
          </p>
        </div>
      </section>
    </>
  );
};

export default Terms;
